var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ew-page-top-section"},[(_vm.image)?_c('div',{staticClass:"main-image-bg",style:({ 'background-image': ("url(" + _vm.image + ")") })},[_c('BookNow',{attrs:{"title":_vm.title,"address":_vm.address}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }